// extracted by mini-css-extract-plugin
export default {"pannel_wrapper":"panel-read-only_pannel_wrapper__PucL4","opened":"panel-read-only_opened__WM1C+","title_wrapper":"panel-read-only_title_wrapper__BM2ru"};